import { render } from "./SelecionarStatusRequisicaoAutorizacao.vue?vue&type=template&id=05985178&ts=true"
import script from "./SelecionarStatusRequisicaoAutorizacao.vue?vue&type=script&lang=ts"
export * from "./SelecionarStatusRequisicaoAutorizacao.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__